import React, { Component } from 'react';
import { Container, UncontrolledTooltip } from 'reactstrap';
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import isUndefined from "lodash/isUndefined"
import { withRouter } from 'react-router-dom';
import Slider from "react-slick";
import MetaTags from '../../components/SEO/MetaTags'
import { handleRequestError, Request } from '../../helpers/request'
import { businessUnitOptions } from '../../helpers/select'
import LocaleLink, { addLocalePrefix } from '../../components/Routes/LocaleLink'

class TeamPage extends Component {
    state = {
        jobsSelected: [],
        selectedConsultant: {},
        consultants: [],
        filteredConsultants: [],
        ellipsisText: {
            skills: false,
            assets: false
        },
        page: 0
    };

    componentDidMount() {
        this.fetch();
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.jobsSelected !== prevState.jobsSelected) {
            this.displaySliders();
        }

        const consultantRouteSlug = this.props.match?.params?.consultant

        if (this.state.consultants.length) {
            if (!consultantRouteSlug) {
                const [consultant] = this.state.consultants
                this.props.history.replace(addLocalePrefix(`/team/${consultant.slug}`))
            } else if (this.state.selectedConsultant?.slug !== consultantRouteSlug) {
                const selectedConsultant = this.state.consultants.find(c => c.slug === consultantRouteSlug)
                this.setState({ selectedConsultant })
            }
        }
        if (this.state.filteredConsultants.filter(c => c.slug === consultantRouteSlug).length === 0) {
            const [consultant] = this.state.filteredConsultants
            this.props.history.push(addLocalePrefix(`/team/${consultant.slug}`))
        }
    };

    fetch() {
        Request.get('team')
            .then(datas => {
                this.setState({ consultants: datas, filteredConsultants: datas });
            })
            .then(() => {
                this.isEllipsisActive();
            })
            .catch(handleRequestError);
    };

    tooltipSkills = (width) => {
        const tooltip = {
            backgroundColor: '#000',
            fontSize: '1.6em',
            fontFamily: "toska-medium",
            boxShadow: '1px 1px 2px #FFF',
            color: '#fff',
            position: 'relative',
            margin: 'auto',
            'textAlign': 'center',
            top: '.75em',
            transform: 'skew(-20deg,0)',
            right: '.15em',
        };
        tooltip.width = width + 'px';
        tooltip.minWidth = width + 'px';
        return { ...tooltip };
    };


    displayFilter = () => {
        return businessUnitOptions.map((option, id) => {
            return <li key={id}>
                <label className="checkbox-warning-round">
                    <input
                        onChange={(e) => this.toggleJobsSelection(e)}
                        checked={this.state.jobsSelected.includes(option.value)}
                        type="checkbox"
                        id={option.value}
                    />
                    <span>{option.label.toUpperCase()}</span>
                </label>
            </li>
        });
    };

    toggleJobsSelection = (e) => {
        const selected = this.state.jobsSelected;
        const pos = selected.indexOf(e.target.id);
        this.setState({ page: 0, ellipsisText: { assets: false, skills: false } });
        if (pos !== -1) {
            selected.splice(pos, 1);
            return this.setState({ jobsSelected: selected }, this.filterConsultants.bind(this));
        } else {
            return this.setState({ jobsSelected: [...selected, e.target.id] }, this.filterConsultants.bind(this));
        }
    };

    filterConsultants = () => {
        const { consultants, jobsSelected } = this.state
        if (!Array.isArray(consultants) || consultants.length === 0) {
            return
        }

        if (jobsSelected.length === 0) {
            this.setState({ filteredConsultants: consultants })
            return
        }

        const list = [];
        jobsSelected.forEach((businessUnit) => {
            if ((businessUnit === 'other' || businessUnit === 'tech') && !list.includes('tech')) list.push('tech');

            if (businessUnit === 'sales' || businessUnit === 'marketing') {
                if (!list.includes('sales')) list.push('sales');
                if (!list.includes('marketing')) list.push('marketing');
            }

            if (businessUnit === 'design' || businessUnit === 'product') {
                if (!list.includes('sales')) list.push('sales');
                if (!list.includes('marketing')) list.push('marketing');
                if (!list.includes('tech')) list.push('tech');
            }
        });

        const filteredConsultants = consultants.filter(consultant => list.some(elem => elem.toLowerCase() === consultant.business_unit))
        this.setState({ filteredConsultants })
    };

    displaySliders = () => {
        const maxNumber = window.matchMedia("(min-width: 768px)").matches ? 16 : 12;
        const { filteredConsultants } = this.state;
        // Define the number of pages and map over
        return filteredConsultants.length > 0 && [...Array(Math.ceil(filteredConsultants.length / maxNumber))].map((undefined, pageId) => {
            return (
                <div className="team-group" key={pageId}>
                    {
                        [...Array(maxNumber)].map((undefined, id) => {
                            return this.displayPlayer(filteredConsultants, id + 1, maxNumber);
                        })
                    }
                </div>
            );
        });
    };

    displayPlayer = (consultants, id, maxNumber) => {
        const playerId = (this.state.page * maxNumber) + (id - 1);
        const consultant = consultants[playerId];
        const isDefined = !isUndefined(consultant);

        const handlePlayerClick = () => {
            if (!isDefined || !consultant?.slug) {
                return
            }
            this.props.history.push(addLocalePrefix(`/team/${consultant.slug}`))
        }

        return (
            <div
                className={
                    `team-member member${id}
                    ${isDefined && this.state.selectedConsultant.id === consultant.id && 'active'}
                    ${!isDefined && 'no-hover'}`
                }
                onClick={handlePlayerClick}
                id={`player${id}`}
                key={id}
            >
                <figure>
                    {isDefined &&
                    <img className={'team-image'}
                         src={consultant.attachment ? consultant.attachment.url : `https://via.placeholder.com/150.png/070014/fff?text=${consultant.firstname}`}
                         alt="img" />
                    }
                </figure>
                {isDefined &&
                <div className={'tooltip-container'}>
                    <span>
                        {consultant.firstname}
                    </span>
                </div>
                }
            </div>
        )
    };

    isEllipsisActive = () => {
        const assets = document.getElementById('assets');
        const skills = document.getElementById('skills');
        if (assets.offsetWidth && skills.offsetWidth) {
            this.setState({
                ellipsisText: {
                    ...this.state.ellipsisText,
                    assets: assets.offsetWidth < assets.scrollWidth,
                    skills: skills.offsetWidth < skills.scrollWidth
                }
            });
        } else if (assets.offsetWidth) {
            this.setState({
                ellipsisText: {
                    ...this.state.ellipsisText,
                    assets: assets.offsetWidth < assets.scrollWidth
                }
            });
        } else if (skills.offsetWidth) {
            this.setState({
                ellipsisText: {
                    ...this.state.ellipsisText,
                    skills: skills.offsetWidth < skills.scrollWidth
                }
            });
        }
    };

    defineTooltip = (id, text) => {
        const width = document.getElementById(id).offsetWidth;
        return (width &&
            <UncontrolledTooltip
                style={this.tooltipSkills(width)}
                placement="bottom"
                target={id}
                hideArrow={true}
                fade={false}
            >
                {text}
            </UncontrolledTooltip>
        );
    };

    render() {
        if (this.state.consultants.length === 0) {
            return null
        }

        const settings = {
            dots: false,
            infinite: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            draggable: false,
            beforeChange: (current, next) => this.setState({ page: next })
        };

        return (
            <div className="team-page">
                <MetaTags page="team" />
                <section className="sec-team">
                    <Container>
                        <div className="team-head">
                            <h1 className="line-heading">
                                <FormattedMessage
                                    id="portfolio.team.title"
                                    defaultMessage="LA DREAM TEAM"
                                />
                            </h1>
                            <p>
                                <FormattedMessage
                                    id="portfolio.team.subtitle"
                                    defaultMessage="Plus de 60 spécialistes qui forment une équipe soudée pour trouver les meilleurs talents et les jobs qu’il vous faut."
                                />
                            </p>
                        </div>
                        <div className="player-type">
                            <h2>
                                <FormattedMessage
                                    id="portfolio.team.player"
                                    defaultMessage="Select your player!"
                                />
                            </h2>
                            <div className="check-list">
                                <label>
                                    <FormattedMessage
                                        id="portfolio.team.business_unit.label"
                                        defaultMessage="Pour quel type de poste souhaitez-vous postuler ?"
                                    />
                                </label>
                                <ul>
                                    {this.displayFilter()}
                                </ul>
                            </div>
                        </div>
                        <div className="team-wrap">
                            <div className="team-block">
                                <Slider className="team-slider" {...settings}>
                                    {this.displaySliders()}
                                </Slider>
                            </div>
                            {this.renderSelectedConsultant()}
                        </div>
                    </Container>
                </section>
            </div>
        )
    }

    renderSelectedConsultant() {
        if (!this.state.selectedConsultant) {
            return null
        }

        const {
            years_of_exp,
            firstname,
            nickname,
            linkedin,
            position,
            skills,
            short_bio,
            attachment,
            job_order_count,
            id
        } = this.state.selectedConsultant;

        const years = years_of_exp >= 10 ? 10 : years_of_exp;
        const backgroundImage = attachment ? `url(${encodeURI(attachment.url)})` : null
        const lang = document.getElementById('skillsTitle') && document.getElementById('skillsTitle').innerHTML;
        const skillsSpan = lang === 'Other skills' && '75px';

        return (
            <div className="team-info-block">
                <div className="member-profile-avatar" style={{ backgroundImage }} />
                <div className="member-info">
                    <div className="hexagon">
                        <span>{years_of_exp}<span className='xp'>xp</span></span>
                    </div>
                    <ul>
                        <li><h2>{firstname}</h2></li>
                        {linkedin && linkedin !== '' &&
                        <li>
                            <a href={linkedin} target='_blank'>
                                <FontAwesomeIcon icon={faLinkedin} />&nbsp;
                            </a>
                        </li>}
                    </ul>
                    <span className="text-thin">{position}</span>
                    <div className="progress-wrap">
                        <div className="progress-line"
                             style={{ width: `${years * 10}%` }}>&nbsp;</div>
                    </div>
                    {job_order_count > 0 &&
                    <LocaleLink to={{ pathname: `/jobs-consultant/${id}` }}
                          rel="nofollow"
                          className="btn-link user-jobs">
                        <FormattedMessage
                            id="portfolio.job.jobs.see_offers"
                            defaultMessage="Voir ses annonces"
                        />
                        <i>
                            <FontAwesomeIcon icon={faArrowRight} />
                        </i>
                    </LocaleLink>}
                </div>
                <div className="shape-angle shape1">
                    <span className="text-thin">
                        <FormattedMessage
                            id="portfolio.team.nickname"
                            defaultMessage="Surnom"
                        />
                    </span>
                    <ul className="member-quility">
                        <li className="li-quality">
                            {nickname}
                        </li>
                    </ul>
                </div>
                <div className="shape-angle shape2">
                    <span className="text-thin" id="skillsTitle">
                        <FormattedMessage
                            id="portfolio.team.skills"
                            defaultMessage="Skills"
                        />
                    </span>
                    <ul className="member-quility">
                        <li id="skills" className="li-quality" style={{ marginLeft: skillsSpan }}>
                            {skills}
                        </li>
                        {this.state.ellipsisText.skills && this.defineTooltip('skills', skills)}
                    </ul>
                </div>
                <div className="shape-angle shape3">
                    <span className="text-thin">
                        <FormattedMessage
                            id="portfolio.team.short_bio"
                            defaultMessage="Atouts"
                        />
                    </span>
                    <ul className="member-quility">
                        <li id="assets" className="li-quality">
                            {short_bio}
                        </li>
                        {this.state.ellipsisText.assets && this.defineTooltip('assets', short_bio)}
                    </ul>
                </div>
            </div>
        )
    }
}

export default withRouter(TeamPage);
